import React, { useState } from 'react';
import { MapPin } from 'lucide-react';
import ApplicationModal from './ApplicationModal';

const RequirementsForSuccess = () => {
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);

  const requirements = [
    {
      title: 'A DEEP CONNECTION TO LAND',
      description: 'Passion for hunting, conservation, farming, or land management, and a wealth of knowledge your clients can rely on.'
    },
    {
      title: 'FULL-TIME COMMITMENT',
      description: 'Dedication to the craft, and singular focus of selling land at the highest level possible.'
    },
    {
      title: 'A STRONG WORK ETHIC',
      description: 'Showing up, ready to solve the day\'s challenges.'
    },
    {
      title: 'PROFESSIONALISM',
      description: 'Respect, responsiveness, and doing things the right way, every day, with a smile.'
    },
    {
      title: 'FINANCIAL RESOURCES',
      description: 'Ready, willing, and able to make the financial investment necessary to operate in a professional manner.'
    }
  ];

  const handleApplyClick = () => {
    setIsApplicationModalOpen(true);
  };

  return (
    <>
      <section id="requirements" className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16 animate-slide-up">
            <h2 className="text-4xl font-bold text-kiloterra-dark mb-6 uppercase">
              Requirements for Success
            </h2>
            {/* Yellow horizontal line */}
            <div className="flex justify-center mb-6">
              <div className="w-16 h-1 bg-kiloterra-yellow"></div>
            </div>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
              There's <u>no prior real estate experience necessary</u>. Our best-in-class training will provide the skills needed for a successful career. However, the following qualities are required:
            </p>
          </div>

          {/* Requirements List */}
          <div className="shadow-lg mb-12 overflow-hidden">
            <div className="space-y-0">
              {requirements.map((requirement, index) => (
                <div
                  key={index}
                  className={`p-4 animate-slide-up ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0 mt-1">
                      <MapPin className="h-6 w-6 text-kiloterra-yellow" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-kiloterra-dark mb-1 uppercase">
                        {requirement.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {requirement.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button 
              onClick={handleApplyClick}
              className="bg-kiloterra-yellow text-kiloterra-dark px-12 py-4 font-bold text-lg hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105 uppercase tracking-wide"
            >
              Apply Now
            </button>
          </div>
        </div>
      </section>

      <ApplicationModal 
        isOpen={isApplicationModalOpen} 
        onClose={() => setIsApplicationModalOpen(false)}
        source="requirements_section"
      />
    </>
  );
};

export default RequirementsForSuccess;